import { useState } from 'react';

import { Divider } from 'antd';
import { Popup } from 'antd-mobile';
import { Row, SearchOutlined, Space, Text } from 'farmhub-ui-core';

import { TickIcon, TriangleIcon } from 'components/Icon';
import { theme } from 'styled';

import {
  FilterMobileWrapper,
  MobileWrapper,
  PopupRow,
  SelectEntityTypeWrapper,
  SelectMobileWrapper,
  WrapperMobile,
} from './styles';

interface MenuSelectionProps {
  selected: string;
  entityType: string;
  selectItems: any[];
  searchValue: string;
  handleChangeSelected: (e: string) => void;
  handleChangeSearchValue: (e: string) => void;
}

const MenuSelectionDesktop = ({
  selected,
  entityType,
  selectItems,
  searchValue,
  handleChangeSelected,
  handleChangeSearchValue,
}: MenuSelectionProps): JSX.Element => {
  const [visible, setVisible] = useState(false);
  const handleChange = e => {
    handleChangeSearchValue(e.target.value);
  };

  return (
    <FilterMobileWrapper>
      <SelectEntityTypeWrapper
        justifyContent="space-between"
        onClick={() => setVisible(true)}
      >
        <Row justifyContent="flex-start" width="100%">
          {selectItems.find(item => item.entityType == entityType).icon}
          <Space width={6} />
        </Row>

        <TriangleIcon />
      </SelectEntityTypeWrapper>

      <SelectMobileWrapper>
        <MobileWrapper
          allowClear
          background={theme.colors.text.white}
          height={theme.input.height.sm}
          placeholder="Tìm theo tên thực thể"
          prefix={
            <SearchOutlined
              style={{ fontSize: '18px', color: theme.colors.text.secondary }}
            />
          }
          size="large"
          value={searchValue}
          onChange={handleChange}
        />
      </SelectMobileWrapper>

      <Popup
        bodyStyle={{
          borderTopLeftRadius: theme.radius.md,
          borderTopRightRadius: theme.radius.md,
          height: 'fit-content',
          maxHeight: '-webkit-fill-available',
          padding: `0px 0px ${theme.app.padding.vertical} 0px`,
          fontSize: theme.font.size.xs,
          position: 'fixed',
          bottom: 0,
          left: 0,
        }}
        style={{
          zIndex: 1100,
        }}
        visible={visible}
        onMaskClick={() => {
          setVisible(false);
        }}
      >
        <PopupRow>
          <Text color="primary" size="sm" weight="bold">
            Tài khoản
          </Text>
        </PopupRow>
        <Divider style={{ margin: '0px' }} />
        {selectItems.map(item => (
          <WrapperMobile
            active={selected == item.entityType}
            onClick={() => {
              setVisible(false);
              item.action();
              handleChangeSelected(item.entityType);
            }}
          >
            <Row justifyContent="space-between">
              <Row width="fit-content">
                {item.icon}
                <Space width={12} />
                <Text color="primary" weight="medium">
                  {item.name}
                </Text>
              </Row>
              {selected == item.entityType && (
                <TickIcon color="main" width={18} />
              )}
            </Row>
          </WrapperMobile>
        ))}
      </Popup>
    </FilterMobileWrapper>
  );
};

export default MenuSelectionDesktop;
